import React from 'react'
import { useTranslation } from 'react-i18next'
import SoundSelector from "./SoundSelector";

const SelectionSoundType = (props) => {
	const { label } = props;
	const { t } = useTranslation('translation', { keyPrefix: 'manageVehiclesPage.fleetConfigurationContainer.editProfile.selectionSoundType' });

	return (
		<div className="toggle-wrapper">
			<label className="settings-title">{label || t('eventAudio')}</label>
			<SoundSelector {...props} />
		</div>
	)
}

export default SelectionSoundType;
